/**
 * Shared CSV building/download helpers
 * @module lib/utils/csv
 */

// UTF-8 BOM — ensures Excel opens Arabic text correctly
const BOM = String.fromCharCode(0xfeff);

export function escapeCsvCell(value: string): string {
  // Wrap in quotes if the value contains commas, quotes, or newlines
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function buildCsvString(rows: string[][]): string {
  const lines = rows.map((row) => row.map(escapeCsvCell).join(","));
  return BOM + lines.join("\r\n");
}

export function todayDateString(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function downloadCsv(content: string, filename: string): void {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Release the object URL after a short delay to allow the download to start
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
